import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { api } from "@/lib/api";
import Releases from "./Releases";
import Albums from "./Albums";
import NewsAdmin from "./NewsAdmin";
import { BespokeInbox, ContactInbox } from "./Enquiries";
import Subscribers from "./Subscribers";
import Settings from "./Settings";

const TABS = [
  ["releases", "Releases"],
  ["albums", "Albums"],
  ["news", "News Posts"],
  ["bespoke", "Bespoke Enquiries"],
  ["contact", "Contact Inbox"],
  ["fans", "Launch List"],
  ["settings", "Site Settings"],
];

export default function Admin() {
  const [authed, setAuthed] = useState(null);
  const [tab, setTab] = useState("releases");
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/auth/me")
      .then(() => setAuthed(true))
      .catch(() => navigate("/admin/login"));
  }, [navigate]);

  if (!authed)
    return <div className="min-h-screen bg-navy-950 flex items-center justify-center text-slate-500">Checking session…</div>;

  const logout = () => {
    localStorage.removeItem("ohr_token");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-navy-950 text-slate-200 flex flex-col md:flex-row" data-testid="admin-dashboard-root">
      <aside className="md:w-60 shrink-0 border-b md:border-b-0 md:border-r border-white/5 bg-navy-900/50 md:min-h-screen p-5 flex md:flex-col gap-2 md:gap-1 flex-wrap">
        <div className="flex items-center gap-3 mb-4 md:mb-8 w-full">
          <img src="/assets/logo-dark-square.webp" alt="" className="w-9 h-9 object-cover rounded-full" />
          <span className="font-serif text-sm tracking-widest uppercase text-slate-100">OHR Admin</span>
          <button onClick={logout} data-testid="admin-logout-btn" aria-label="Log out"
            className="ml-auto text-slate-500 hover:text-gold-300 transition-colors">
            <LogOut size={16} />
          </button>
        </div>
        {TABS.map(([id, label]) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            data-testid={`admin-tab-${id}`}
            className={`text-left text-xs tracking-[0.15em] uppercase rounded-lg px-4 py-2.5 transition-colors ${
              tab === id ? "bg-gold-400/15 text-gold-200 border border-gold-400/30" : "text-slate-400 hover:text-gold-200 border border-transparent"
            }`}
          >
            {label}
          </button>
        ))}
      </aside>
      <main className="flex-1 p-5 sm:p-8 max-w-6xl w-full mx-auto">
        {tab === "releases" && <Releases />}
        {tab === "albums" && <Albums />}
        {tab === "news" && <NewsAdmin />}
        {tab === "bespoke" && <BespokeInbox />}
        {tab === "contact" && <ContactInbox />}
        {tab === "fans" && <Subscribers />}
        {tab === "settings" && <Settings />}
      </main>
    </div>
  );
}
